import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { goToPage } from '@epi-actions/navigation';
import { routerPaths } from '@epi-constants/routerPaths';
import { addLocale, getLocale, removeLocale } from '@epi-helpers/UrlHelpers';
import {
  MANAGE_EMPLOYEES_SEARCH_NAME,
  TabsManageEmployees
} from '@epi-constants/manageEmployees';

export const useManageEmployeesTabs = () => {
  const [showFooter, setShowFooter] = useState(false);
  const { search, pathname } = useLocation();
  const dispatch = useDispatch();

  const locale = getLocale(pathname) || 'fi';

  const getTabPath = tabName =>
    addLocale(
      locale,
      tabName === TabsManageEmployees.massUpload
        ? routerPaths.beneficiariesHrImportHistory
        : routerPaths.beneficiaries
    );

  const handleFooterVisibility = tabName =>
    setShowFooter(tabName === TabsManageEmployees.employees);

  const handleURLChange = tabName => dispatch(goToPage(getTabPath(tabName)));

  const handleOnTabChange = tabName => {
    handleFooterVisibility(tabName);
    handleURLChange(tabName);
  };

  const urlParams = new URLSearchParams(search);
  const indexType = urlParams.get(MANAGE_EMPLOYEES_SEARCH_NAME);
  const currentPath = removeLocale(pathname).replace(/\/+$/, '') || '/';

  const defaultTabNameByPath =
    currentPath === routerPaths.beneficiariesHrImportHistory
      ? TabsManageEmployees.massUpload
      : TabsManageEmployees.employees;

  const defaultTabName =
    indexType && TabsManageEmployees[indexType]
      ? TabsManageEmployees[indexType]
      : defaultTabNameByPath;

  return {
    showFooter,
    handleOnTabChange,
    defaultTabName
  };
};
